<script lang="ts" setup>
import { storeToRefs } from "pinia";
const documentId = inject("documentId") as any;
const documentSavingStatusStore = useDocumentSavingStatusStore(documentId);
const { isSaving } = storeToRefs(documentSavingStatusStore);
</script>

<template>
  <div
    v-tooltip="isSaving ? 'Saving...' : 'Saved'"
    class="flex items-center justify-center w-10 h-10"
    role="status"
    :aria-label="isSaving ? 'Saving changes' : 'Saved'"
  >
    <icon
      v-if="isSaving != true"
      name="dashicons:cloud-saved"
      size="30"
      class="text-success-default"
    />
    <icon v-else name="material-symbols:sync" size="28" class="animate-spin text-success-default" />
  </div>
</template>

<style scoped></style>
